export default [
  {
    path: '/app/feedbacks',
    name: 'Feedbacks',
    component: () => import('@/views/Feedbacks/Index.vue'),
    meta: {
      pageTitle: 'Geri Bildirimler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'FEEDBACKS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/feedbacks/view/:id',
    name: 'FeedbackView',
    component: () => import('@/views/Feedbacks/View.vue'),
    meta: {
      pageTitle: 'Geri Bildirimler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/feedbacks',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'FEEDBACK_VIEW',
      action: 'read',
    },
  },
]
